export const GET_ALL_USERS = '/users/';
export const GET_USER_DATA = '/users/';
export const UPDATE_USER = '/users/';
export const DELETE_USER = '/users/:id';
